import * as React from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import BButton from '../../components/general/BButton';
import TextFieldSC from "../../components/TextFieldSC";
import DesktopDatePickerSC from "../../components/DesktopDatePickerSC";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import TextareaAutosize from '@mui/base/TextareaAutosize';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import helper from "../../utils/helper"
import moment from 'moment';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/th';

class SlideBottomPage extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      error: {},
      isSubmit: false,
      isError: false,
      data: { 
        remark: '' 
      }
    }
    this.onConfirm = this.onConfirm.bind(this)
    this.onClear = this.onClear.bind(this)
  }

  checkValidation(data){
    console.log('data >>', data)
    // console.log("this.state.isSubmit",this.state.isSubmit);
    if (!this.state.isSubmit) {
      return false;
    }
    let error = this.state.error;
    let required = ["remark"];
    let hasError = false;
    for (var i in data) {
      if (!data[i] && required.indexOf(i) > -1) {
        error[i] = true;
        hasError = true;
      } else {
        error[i] = false;
      }
    }
    this.setState({ error: error });
    return hasError;
  }

  changeValue(e, type, targetValue = "target"){
    console.log(e, type, targetValue);
    let value = null;
    if (targetValue === "target") {
      value = e.target.value;
    } else if (targetValue === "checked") {
      value = e.target.checked;
    } else {
      value = e;
    }
    console.log('value >>', value)
    let { data } = this.state;
    const nextState = data;
    nextState[type] = value;
    this.checkValidation(nextState);
    console.log("nextState", nextState);
    this.setState({ data: nextState });
  }
  onConfirm() {
    const { data } = this.state
    if(data.remark) {
      this.props.onConfirm(data.remark)
    } else {
      this.setState({ isError: true })
    }
  }
  onClear(){
    const data = this.state
    data.remark = ''
    this.setState({ data })
  }

  render() {
    const { data, isError } = this.state
    const { isShow, setIsShow } = this.props
    const { currentDate, slideData } = this.props
    const aaa = `${helper.FN.numberToshift(slideData.workShiftSchedule?.shift)} (${helper.FN.toTimeHM(slideData.workShiftSchedule?.shiftTimeFrom)} - ${helper.FN.toTimeHM(slideData.workShiftSchedule?.shiftTimeTo)} น.)`
    return <div>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'th'}>
          <SwipeableDrawer
            anchor={'bottom'}
            open={isShow}
            onClose={() => setIsShow(false)}
            onOpen={() => setIsShow(true)}
          >
            <Box
              sx={{ width: 'auto' }}
              role="presentation"
            >
              <div className='approve-container'>
                <div className='form-checkin'>
                  <TextFieldSC
                    variant="standard"
                    fullWidth
                    value={moment(currentDate,'YYYY-MM-DD').format('DD-MM-YYYY')}
                    disabled={true}
                  />
                  <TextFieldSC
                    variant="standard"
                    fullWidth
                    value={aaa}
                    disabled={true}
                  />
                  <div>เหตุผล<span style={{ color: 'red' }}>*</span></div>
                  <TextareaAutosize
                    minRows={4}
                    value={data?.remark}
                    onChange={(e) => this.changeValue(e, "remark")}
                    style={{ width: '100%' }}
                  />
                </div>
                <BButton setStyle='block' onClick={this.onConfirm}>ขออนุมัติเวลา</BButton>
              </div>
            </Box>
          </SwipeableDrawer>
        </LocalizationProvider>
    </div>
  }
}

export default SlideBottomPage